import { Button } from '@lifeomic/chroma-react/components/Button';
import React from 'react';
import { useIntl } from 'react-intl';
import { KnownImpressionTypes } from '../../AITools/ImpressionEditor/ImpressionItem';
import { messages } from '../messages';
import { AgentInput } from '../useExecutiveSummaryGeneration';
import { ImpressionType } from './GenerateMenuModal';
import { useRequestExecutiveSummary } from './useRequestExecutiveSummary';

type GenerateExecutiveSummaryProps = {
  patientId: string;
  isRegenerate: boolean;
  crdDurableId?: string;
  modelId?: string;
  instructions: string;
  impressionTypeToGenerate: ImpressionType;
  availableImpressionTypes: KnownImpressionTypes[];
  onGenerate: () => void;
  disabled?: boolean;
};

function GenerateExecutiveSummary({
  patientId,
  isRegenerate,
  crdDurableId,
  modelId,
  instructions,
  impressionTypeToGenerate,
  availableImpressionTypes,
  onGenerate,
  disabled,
}: GenerateExecutiveSummaryProps) {
  const { formatMessage } = useIntl();
  const { requestExecutiveSummary } = useRequestExecutiveSummary({ patientId });

  const instructionsPayload = instructions
    ? impressionTypeToGenerate === 'all'
      ? availableImpressionTypes.map(impressionType => ({
          summaryType: impressionType,
          instructions,
        }))
      : [
          {
            summaryType: impressionTypeToGenerate,
            instructions,
          },
        ]
    : undefined;

  const handleClick = () => {
    requestExecutiveSummary(
      {
        ...(crdDurableId && { crdId: crdDurableId }),
        ...(instructionsPayload && {
          instructions: instructionsPayload,
        }),
        ...(modelId && { modelId }),
        requestedSummaries:
          impressionTypeToGenerate === 'all'
            ? undefined
            : [impressionTypeToGenerate],
        skipActionItems: isRegenerate ? true : false,
      } as AgentInput,
      {
        isRegenerate,
      },
    );
    onGenerate?.();
  };

  return (
    <Button onClick={handleClick} fullWidth disabled={disabled}>
      {formatMessage(
        isRegenerate ? messages.regenerate : messages.startNewGeneration,
      )}
    </Button>
  );
}

const DisabledGenerateExecutiveSummary: React.FC<
  Pick<GenerateExecutiveSummaryProps, 'isRegenerate'>
> = ({ isRegenerate }: Pick<GenerateExecutiveSummaryProps, 'isRegenerate'>) => {
  return (
    <GenerateExecutiveSummary
      instructions={''}
      impressionTypeToGenerate={'all'}
      availableImpressionTypes={[]}
      onGenerate={() => {
        void 0;
      }}
      patientId={''}
      isRegenerate={isRegenerate}
      disabled
    />
  );
};

GenerateExecutiveSummary.Disabled = DisabledGenerateExecutiveSummary;

export { GenerateExecutiveSummary };
